import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import { throttle, screenType } from '../../components/common/utils.js';
import FilterBox from '../../components/common/FilterBox/index.jsx';
import { enDescList, cnDescList, contactPreferenceOptions, enInterestedOptions, cnInterestedOptions } from './config.js';
import { pushReport } from '../../api/sys'
import { useQueryObject } from '../../hooks/use-query.js'

import "./index.scss";

function WhitePaper() {
  const { utm_source = '', referer = '' } = useQueryObject();

  const { t } = useTranslation();
  let { i18n } = useTranslation();
  const [type, setType] = useState("");
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contactPreference, setContactPreference] = useState([]);
  const [account, setAccount] = useState("");
  const [country, setCountry] = useState("");
  const [interested, setInterested] = useState([]);
  const [agree, setAgree] = useState(false);

  const handleCpSelection = (filterType, newSelectedTags) => {
    setContactPreference(newSelectedTags);
  };

  const handleInSelection = (filterType, newSelectedTags) => {
    setInterested(newSelectedTags);
  };

  const lanUrlMap = {
    cn: 'https://xmp-material.mobvista.com/static/global-mobile-gaming-ua-trends-strategy-repor-q1-q3-2025-cn.pdf',
    en: 'https://xmp-material.mobvista.com/static/global-mobile-gaming-ua-trends-strategy-repor-q1-q3-2025.pdf',
  }

  // function mapSelectionsToKeys(selections = []) {
  //   const MAP = {
  //       'Media Buying Management': 'campaign_xmp',
  //       'Mobile Ad Intelligence': 'reyun_lead',
  //   };

  //   return selections
  //       .map(s => MAP[s])
  //       .filter(Boolean); // 过滤掉未映射项
  // }

  function getParams() {
    if (i18n.language === 'en') {
      return {
        name,
        company_name: companyName,
        email: businessEmail,
        job: jobTitle,
        phone: phoneNumber,
        contact: contactPreference[0],
        contact_account: account,
        country_region: country,
        interested,
        utm_source,
        referer,
        lang: i18n.language,
      }
    } else {
      const tempInterested = interested.map(item => {
        if (item === '广告智能投放管理') return 'Media Buying Management'
        if (item === '广告数据洞察分析') return 'Mobile Ad Intelligence'
        return '';
      })
      return {
        name,
        company_name: companyName,
        email: businessEmail,
        job: jobTitle,
        phone: phoneNumber,
        interested: tempInterested,
        utm_source,
        referer,
        lang: i18n.language,
      }
    }
  }

  const handleReport = debounce(
    async () => {
      console.log(111, getParams())
      setErrorText('')
      setLoading(true);

      const { isSuccess, msg } = await handleCheckVerify();

      // 是否校验通过
      if (!isSuccess) {
        setErrorText(msg)
        setLoading(false);
        return;
      }

      // const tempInterested = mapSelectionsToKeys(interested);

      const params = getParams();

      // 提交
      const result = await pushReport(params)

      if (result?.status === 200 && result?.data?.business_code === 200) {
        // 提交成功
        const url = lanUrlMap[i18n.language];
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
      }

      setLoading(false);
    },
    500,
    { leading: false, trailing: true }
  );

  function getFields() {
    if (i18n.language === 'en') {
      return {
        name,
        companyName,
        jobTitle,
        businessEmail,
        phoneNumber,
        country,
        contactPreference,
        interested,
      }
    }else {
      return {
        name,
        companyName,
        jobTitle,
        businessEmail,
        phoneNumber,
        interested,
      }
    }
  }

  async function handleCheckVerify() {
    const fields = getFields();

    const isFilled = (val) => {
        if (Array.isArray(val)) return val.length > 0;
        if (typeof val === 'string') return val.trim().length > 0;
        return !!val;
    };

    // 先检查是否都非空
    const allFilled = Object.values(fields).every(isFilled);
    if (!allFilled) {
        return { isSuccess: false, msg: t('whitePaper.requireText') };
    }

    // 可选：附加格式校验
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(businessEmail.trim());
    // const phoneOk = phoneNumber.trim().length > 0; // 可替换成具体规则

    if (!emailOk) return { isSuccess: false, msg: t('whitePaper.emailRequireText') };
    // if (!phoneOk) return { isSuccess: false, msg: '请输入有效的手机号' };

    if (!agree) return { isSuccess: false, msg: t('whitePaper.agreeText') };

    return { isSuccess: true, msg: '' };
  };

  const handleResize = useCallback(() => {
    const throttleFn = throttle(() => {
      setType(screenType());
    }, 300);
    throttleFn();
  },[setType]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [handleResize,type]);

  return (
    <div className={`white-paper ${i18n.language}`}>
      <div className="main_container">
        <div className={`banner-section ${i18n.language}`}>
          <div className="left-box">
            <h1 className="title">{ t('whitePaper.title') }</h1>
          </div>
          <div className={`right-box ${i18n.language}`}></div>
        </div>

        <div className="content-section">
          <div className="left-box">
            <div className="main-desc">
              <p>{ t('whitePaper.desc1') }</p>
              <p>{ t('whitePaper.desc2_1') }<span className="font-bold">XMP</span> { t('whitePaper.desc2_2') } <span className="font-bold">Insightrackr</span>, { t('whitePaper.desc2_3') }</p>
            </div>

            <h2 className="main-title">{ t('whitePaper.title2') }</h2>

            {
              (i18n.language === 'cn' ? cnDescList : enDescList).map((item, index) => (
                <div key={`desc-${index}`} className="desc-item-box">
                  <div className="sub-title-box">
                    <i className="anchor-point" />
                    <h3 className="sub-title">{item.title}</h3>
                  </div>
                  <p className="desc">{item.desc}</p>
                </div>
              ))
            }

            <div className="main-desc">
              {
                i18n.language === 'cn' ? (<p>{ t('whitePaper.desc3') }</p>) : (<p>Download the full report to explore how <span className="font-bold">XMP</span> and <span className="font-bold">Insightrackr</span> combine data intelligence and campaign insights to reveal the strategies shaping mobile game advertising in 2025.</p>)
              }
              
            </div>
          </div>
          <div className="right-box">
            <div className="form-wrapper">
              <h4 className="title">{ t('whitePaper.title3') }</h4>
              <div className="form-list">
                <div className="form-item">
                  <input className="form-input" type="text" placeholder={t('whitePaper.label1')} value={name} onChange={(e) => setName(e.target.value)} />
                </div>

                <div className="form-item">
                  <input className="form-input" type="text" placeholder={t('whitePaper.label2')} value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                </div>

                <div className="form-item">
                  <input className="form-input" type="text" placeholder={t('whitePaper.label3')} value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
                </div>

                <div className="form-item">
                  <input className="form-input" type="text" placeholder={t('whitePaper.label4')} value={businessEmail} onChange={(e) => setBusinessEmail(e.target.value)} />
                </div>

                <div className="form-item">
                  <input className="form-input" type="text" placeholder={t('whitePaper.label5')} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                </div>

                {
                  i18n.language === 'en' ? (
                      <div className="form-item">
                        <div className="filter-wrapper">
                          <FilterBox 
                            limit={1}
                            placeholder={t('whitePaper.label9')}
                            options={contactPreferenceOptions} 
                            currentTag={contactPreference} 
                            onDone={handleCpSelection}
                          />
                        </div>
                        
                        <div className="acc-box">
                          <input className="form-input" type="text" placeholder={t('whitePaper.label8')} value={account} onChange={(e) => setAccount(e.target.value)} />
                        </div>
                      </div>
                    ) : null
                }
                

                {
                  i18n.language === 'en' ? (
                    <div className="form-item">
                      <input className="form-input" type="text" placeholder={t('whitePaper.label7')} value={country} onChange={(e) => setCountry(e.target.value)} />
                    </div>
                  ) : null
                }
                

                <div className="form-item">
                  <div className="filter-wrapper-1">
                    <FilterBox 
                      placeholder={t('whitePaper.label6')}
                      options={i18n.language === 'cn' ? cnInterestedOptions : enInterestedOptions} 
                      currentTag={interested} 
                      onDone={handleInSelection}
                    />
                  </div>
                </div>

                <div className="agree-box">
                  <input type="checkbox" className="agree-checkbox" id="agreeCheckbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
                  <div className="agree-text">
                    {t('whitePaper.desc4_1')} <a className="link" href="https://xmp.mobvista.com/en/privacy" target="__blank">XMP</a> {t('whitePaper.desc4_2')} <a className="link" href="https://www.insightrackr.com/en/docs/privacyPolicy/" target="__blank">Insightrackr</a> {t('whitePaper.desc4_3')}
                  </div>
                </div>

                <div className="error-info">{errorText}</div>

                <button onClick={handleReport} className={`button-report button_link ${loading ? 'loading' : ''}`} disabled={loading}>
                  <span className='font-bold'>{t('whitePaper.button')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhitePaper;
